import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const TestResult = () => {
  const [testResults, setTestResults] = useState({});
  const [totalScores, setTotalScores] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userId = searchParams.get('userId');

  useEffect(() => {
    if (userId) {
      fetch(`https://schoolofservice.co.za/backend/maarking.php?userId=${userId}`)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Failed to fetch test results.');
          }
          return response.json();
        })
        .then((data) => {
          if (data.questions_by_course) {
            setTestResults(data.questions_by_course);
          } else {
            setTestResults({});
          }

          if (data.total_scores_by_course) {
            setTotalScores(data.total_scores_by_course);
          } else {
            setTotalScores({});
          }
          setLoading(false);
        })
        .catch((err) => {
          setError(err.message);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [userId]);

  if (loading) {
    return <p>Loading test results...</p>;
  }

  if (error) {
    return <p className="text-danger">Error: {error}</p>;
  }

  if (!userId) {
    return <p className="text-warning">User ID is missing in the URL.</p>;
  }

  return (
    <div className="container">
      <h2 className="text-center mb-4">Your Test Results</h2>
      {Object.keys(testResults).length > 0 ? (
        Object.entries(testResults).map(([courseId, courseData]) => (
          <div key={courseId} className="mb-4">
            <div className="card shadow-sm">
              <div className="card-header bg-primary text-white">
                <h5 className="card-title mb-0">Course: {courseData.courseName}</h5>
              </div>
              <div className="card-body">
                <div className="list-group">
                  {courseData.questions.map((result, index) => (
                    <div key={index} className="list-group-item border-0">
                      <p>
                        <strong>Question:</strong> {result.questionText}
                      </p>
                      <p>
                        <strong>Your Answer:</strong> {result.answer_text}
                      </p>
                      <p>
                        <strong>Correct Answer:</strong> {result.correctAnswer}
                      </p>
                      <p>
                        <strong>Score:</strong> {result.obtained_marks}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="card-footer">
                <h5 className="mb-0 text-secondary">
                  Total Score for {courseData.courseName}:{' '}
                  <strong className="text-success">
                    {totalScores[courseId]?.total_score ?? 'N/A'}
                  </strong>
                </h5>
              </div>
            </div>
          </div>
        ))
      ) : (
        <p>No test results found for this user.</p>
      )}
    </div>
  );
};

export default TestResult;
